/* eslint-disable prettier/prettier */
/* eslint-disable react/no-danger */
import React from 'react';
import uuid from 'uuid/v1';
import PropTypes from 'prop-types';

import { isEmpty } from 'lodash';
import { Grid, IconButton, Paper, Switch, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HtmlIcon from '@mui/icons-material/Html';
import loadTableLayer from '../../../modules/load-table-layer';
import useTimeStore from '../ZustandProvider';
import LayerEditorMaps from '../LayerEditorMaps';
import { isAnnotationsLayer, isAnnotationsRealTime } from '../../../api/Layers/layer-operations';

export const getPopupAnnotations = (properties, maxWidth) => {
  let popup = `<p style="word-wrap: break-word; margin: 0;width: ${maxWidth};"></p>`;
  properties.map(item => {
    if (item.elementType === 'icon') {
      if (!isEmpty(item.caption)) {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
            <img src=${item.value} alt="Descripción de la imagen" style="max-width: ${maxWidth}; height: auto">
          </div>
        </div>
      `;
      } else {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <img src=${item.value} alt="Descripción de la imagen" style="max-width: ${maxWidth}; height: auto">
          </div>
        </div>
      `;
      }
    } else if (item.elementType === 'iframe') {
      popup += `
                <div class="line-container">
                  <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
                    <iframe src=${item.value} height="400" width="800" name="demo"></iframe>
                  </div>
                </div>
              `;
    } else if (item.elementType === 'image') {
      if (!isEmpty(item.value)) {
        if (!isEmpty(item.caption)) {
          popup += `
            <div class="line-container">
              <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
                <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
                <img src=${item.value} alt="Descripción de la imagen" style="max-width: ${maxWidth}; height: auto">
              </div>
            </div>
          `;
        } else {
          popup += `
            <div class="line-container">
              <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
                <img src=${item.value} alt="Descripción de la imagen" style="max-width: ${maxWidth}; height: auto">
              </div>
            </div>
          `;
        }
      }
    } else if (
      item.elementType === 'textarea' ||
      (item.elementType === 'input' && item.dataType === 'text')
    ) {
      if (!isEmpty(item.value)) {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="max-width: ${maxWidth}; word-wrap: break-word;"><h6><b>${item.value}</b></h6></p><hr>
          </div>
        </div>
      `;
      }
    } else if (item.elementType === 'video') {
      const obtenerVideoIdDesdeUrl = url => {
        const match = url.match(
          // eslint-disable-next-line no-useless-escape
          /(?:\?v=|&v=|youtu\.be\/|\/embed\/|\/v\/|\/e\/|youtu\.be\/|\/c\/|\/u\/|\/user\/\w+\/|embed\/|user\/\w+\/videos\/|\/v\/|\/R\/|\/C\/|\/E\/|\/G\/|\/H\/|\/J\/|\/K\/|\/L\/|\/N\/|\/P\/|\/Q\/|\/S\/|\/U\/|\/V\/|\/W\/|\/Y\/|\/hq\/|\/hqdefault\/|\/maxresdefault\/|\/thumbnail\/|\/1.jpg)([^#\&\?]*).*/
        );
        return match && match[1].length === 11 ? match[1] : null;
      };

      const obtenerSitioDesdeUrl = url => {
        const match = url.match(/^(?:https?:\/\/)?(?:www\.)?([a-z0-9-]+)\./i);
        return match ? match[1].toLowerCase() : null;
      };

      const agregarEmbed = url => {
        if (url.includes('/embed/')) {
          return url;
        }
        const sitio = obtenerSitioDesdeUrl(url);

        if (sitio === 'youtube' || sitio === 'youtu') {
          const videoId = obtenerVideoIdDesdeUrl(url);
          if (videoId) {
            return `https://www.youtube.com/embed/${videoId}`;
          }
        }
        return url;
      };

      if (!isEmpty(item.caption) && !isEmpty(item.value)) {
        const videoURL = agregarEmbed(item.value);
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
            <iframe width="100%" height="auto" src=${videoURL} frameborder="0" style="max-width: ${maxWidth}"></iframe>
          </div>
        </div>
      `;
      } else if (!isEmpty(item.value)) {
        const videoURL = agregarEmbed(item.value);
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <iframe width="100%" height="auto" src=${videoURL} frameborder="0" style="max-width: ${maxWidth}"></iframe>
          </div>
        </div>
      `;
      }
    }
    return popup;
  });

  return popup;
};

let isAnnotationState = false;

const InfoLayerSelection = ({ featureProp, map }) => {
  const [propertiesArray, setPropertiesArray] = React.useState([]);
  const [allPropertiesLayer, setAllPropertiesLayer] = React.useState();
  const layers = useTimeStore(state => state.layers);

  const [verHtml, setVerHtml] = React.useState(map.selectedButtons.ViewHtml);
  const setGoToCoordinates = useTimeStore(state => state.setGoToCoordinates);



  const encontrarIndiceIdentico = (allProperties, propertiesArrayProp) => {

    const filterEmptyProperties =(obj) =>{
      return Object.fromEntries(Object.entries(obj).filter(([key, value]) => value !== ""));
    }
    const areObjectsEqual = (obj1, obj2) => {
      const filteredObj1 = filterEmptyProperties(obj1);
      const filteredObj2 = filterEmptyProperties(obj2);
      const keys1 = Object.keys(filteredObj1);
      return keys1.every(key => key in filteredObj2 && filteredObj1[key] === filteredObj2[key]);
    };

    if (isAnnotationState === true) {
      const indexAnnotation = allProperties.findIndex(layerProperty => {
        return areObjectsEqual(propertiesArrayProp.elements, layerProperty.content.elements);
      });
      return indexAnnotation;
    }

    const index = allProperties.findIndex(layerProperty => {
      return areObjectsEqual(propertiesArrayProp, layerProperty.content);
    });

    return index;
  };

  // const clickearLayer = () =>{
  //   geojsonLayer.on({
  //     click: onClickFeature,
  //     popupopen: onPopupOpen,
  //     popupclose: onPopupClose
  //   });
  // }

  const handleDecrease = () => {
    const index = encontrarIndiceIdentico(allPropertiesLayer, propertiesArray);
    if (index !== -1) {
      if (index === 0) {
        setPropertiesArray(allPropertiesLayer[allPropertiesLayer.length - 1].content);
        const coords = allPropertiesLayer[allPropertiesLayer.length - 1].coordinates
        setGoToCoordinates([coords[1], coords[0]])
      } else {
        setPropertiesArray(allPropertiesLayer[index - 1].content);
        const coords = allPropertiesLayer[index - 1].coordinates
        setGoToCoordinates([coords[1], coords[0]])

      }
    }
  };

  const handleIncrease = () => {
    const index = encontrarIndiceIdentico(allPropertiesLayer, propertiesArray);
    if (index !== -1) {
      if (index === allPropertiesLayer.length - 1) {
        setPropertiesArray(allPropertiesLayer[0].content);
        const coords = allPropertiesLayer[0].coordinates
        setGoToCoordinates([coords[1], coords[0]])
      } else {
        setPropertiesArray(allPropertiesLayer[index + 1].content);
        const coords = allPropertiesLayer[index + 1].coordinates
        setGoToCoordinates([coords[1], coords[0]])
      }
    }
  };

  React.useEffect(() => {
    const fetchTableLayer = async layerSelected => {
      let propertiesArrayProp = []
      try {
        isAnnotationState = !!(
          isAnnotationsLayer(layerSelected) || isAnnotationsRealTime(layerSelected)
        );
        const { coordinates, tableBody, tableTitle } = await loadTableLayer(layerSelected);
        const result = tableBody.map((item, index) => {
          const content = tableTitle.reduce((acc, titleItem, idx) => {
            acc[titleItem] = item[idx];
            return acc;
          }, {});
          return {
            content,
            coordinates: coordinates[index]
          };
        });
        if (isAnnotationState === true) {
          propertiesArrayProp= featureProp.properties.template
        } else {
          propertiesArrayProp= featureProp.properties
        }
        setPropertiesArray(propertiesArrayProp);
        setAllPropertiesLayer(result);
        const index = encontrarIndiceIdentico(result, propertiesArrayProp)
        const coords =result[index].coordinates
        setGoToCoordinates([coords[1], coords[0]])
      } catch (err) {
        // Teide error de sacar coordenadas cuadno no hay datos de las layers provenientes de MapBoxGL
        // Bert.alert(`${err}`, 'danger');
      }
    };
    if (isEmpty(featureProp.properties) === false) {
      const layerSelected = layers.find(layer => layer._id === featureProp.id);
      fetchTableLayer(layerSelected);
    }
  }, [featureProp]);

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#757575',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));
  const MaterialUISwitch = styled(Switch)(() => ({
    width: 44,
    height: 22,
    padding: 0,
    margin: 9,
    // display: 'flex',
    transition: 'all .2s',
    borderRadius: 22 / 2,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      opacity: 1,
      backgroundColor: '#2A3F90',
      boxSizing: 'border-box',
      border: '1px solid #2A3F90'
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 17,
      height: 17,
      borderRadius: 17,
      backgroundColor: 'white'
    },
    '& .Mui-disabled + span': {
      backgroundColor: '#9f9f9f',
      border: '1px solid #2A3F90'
    },
    '& .MuiSwitch-switchBase': {
      padding: 2.5,
      '&.Mui-focusVisible': {
        backgroundColor: 'rgba(198, 203, 212, 0.3)',
        '& .MuiSwitch-thumb': {
          backgroundColor: '#777E8C'
        }
      },
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#2A3F90',
          boxSizing: 'border-box',
          border: '1px solid #2A3F90'
        },
        '& .MuiSwitch-thumb': {
          opacity: 1,
          backgroundColor: 'white'
        },
        // ! change width / padding if necessary
        '& svg': {
          width: 15,
          height: 15,
          borderRadius: 17,
          padding: 1,
          backgroundColor: 'white'
        },
        '&.Mui-disabled + span': {
          backgroundColor: '#e4eaf6',
          border: 'none'
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          backgroundColor: 'white'
        }
      }
    }
  }));

  return (
    <>
      {isEmpty(propertiesArray) ? (
        <Grid container direction="row" justifyContent="space-around" alignItems="stretch">
          <Typography variant="h5" gutterBottom>
            Selecciona un punto en el mapa
          </Typography>
        </Grid>
      ) : (
        <>
          <TableContainer component={Paper}>
            {verHtml === true ? (
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">
                      <IconButton
                        size="small"
                        aria-label="Previous"
                        style={{
                          color: '#2A3F90'
                        }}
                        onClick={handleDecrease}
                      >
                        <ChevronLeftIcon />
                      </IconButton>
                      {featureProp.name}
                      <MaterialUISwitch
                        checked={verHtml}
                        checkedIcon={<HtmlIcon />}
                        onClick={() => {
                          setVerHtml(!verHtml);
                        }}
                        label={verHtml === true ? 'Html' : 'Texto'}
                        color="primary"
                      />
                      <IconButton
                        size="small"
                        aria-label="Next item"
                        style={{
                          color: '#2A3F90'
                        }}
                        onClick={handleIncrease}
                      >
                        <ChevronRightIcon />
                      </IconButton>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isAnnotationState === true ? (
                    <>
                      {Object.keys(propertiesArray).map(key => (
                        <StyledTableRow
                          key={uuid()}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell align="center" width="50%" title={key}>
                            {Array.isArray(propertiesArray[key]) ? (
                              <div
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                  __html: getPopupAnnotations(propertiesArray[key], '20vw')
                                }}
                              />
                            ) : (
                              // <Alert severity="info">Funcionalidad en desarrollo</Alert>
                              // eslint-disable-next-line react/no-danger
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: propertiesArray[key]
                                }}
                              />
                            )}
                          </TableCell>
                        </StyledTableRow>
                      ))}
                    </>
                  ) : (
                    <>
                      {Object.keys(propertiesArray).map(key => (
                        <StyledTableRow
                          key={uuid()}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell align="center" width="50%" title={key} key={uuid()}>
                            <div dangerouslySetInnerHTML={{ __html: propertiesArray[key] }} />
                          </TableCell>
                        </StyledTableRow>
                      ))}
                    </>
                  )}
                </TableBody>
              </Table>
            ) : (
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    <StyledTableCell>
                      <IconButton
                        size="small"
                        aria-label="Previous"
                        style={{
                          color: '#2A3F90'
                        }}
                        onClick={handleDecrease}
                      >
                        <ChevronLeftIcon />
                      </IconButton>

                      {featureProp.name}
                      <IconButton
                        size="small"
                        aria-label="Next item"
                        style={{
                          color: '#2A3F90'
                        }}
                        onClick={handleIncrease}
                      >
                        <ChevronRightIcon />
                      </IconButton>
                      <MaterialUISwitch
                        checked={verHtml}
                        checkedIcon={<HtmlIcon />}
                        onClick={() => {
                          setVerHtml(!verHtml);
                        }}
                        label={verHtml === true ? 'Html' : 'Texto'}
                        color="primary"
                      />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isAnnotationState === true ? (
                    <>
                      {Object.keys(propertiesArray).map(key => (
                        <StyledTableRow
                          key={uuid()}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell align="center" width="25%">
                            {key}
                          </TableCell>
                          <TableCell align="center" width="75%">
                            {Array.isArray(propertiesArray[key]) && isAnnotationState === true ? (
                              <Typography variant="body2">
                                {getPopupAnnotations(propertiesArray[key], '20vw')}
                              </Typography>
                            ) : (
                              <Typography variant="body2">{propertiesArray[key]}</Typography>
                            )}
                          </TableCell>
                        </StyledTableRow>
                      ))}
                    </>
                  ) : (
                    <>
                      {Object.keys(propertiesArray).map(key => (
                        <StyledTableRow
                          key={uuid()}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell align="center" width="25%">
                            <Typography variant="body2"> {key}</Typography>
                          </TableCell>
                          <TableCell align="center" width="75%">
                            <Typography variant="body2"> {propertiesArray[key]}</Typography>
                          </TableCell>
                        </StyledTableRow>
                      ))}
                    </>
                  )}
                </TableBody>
              </Table>
            )}
          </TableContainer>

          <br />
          {map.selectedButtons.LayerEditor === true && <LayerEditorMaps />}
        </>
      )}
    </>
  );
};

InfoLayerSelection.defaultProps = {
  featureProp: {},
  LayerEditor: false,
  map: {}
};
InfoLayerSelection.propTypes = {
  featureProp: PropTypes.object,
  LayerEditor: PropTypes.bool,
  map: PropTypes.object
};

export default InfoLayerSelection;
